(function(){
  /******VIDEO REVIEWS SLIDER*******/

  const videoReviewSlider = new Swiper(".video--review--slider",{
    spaceBetween: 10,
    breakpoints: {
      320: {
        slidesPerView: 2.25
      },
      480: {
        slidesPerView: 2
      },
      750: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      }
    }
  })
  var instaFeed = new Swiper(".instFeed", {
  spaceBetween: 00,
  loop: false,
  slidesPerView: 2,
  breakpoints: {
    560: {
      slidesPerView: 2
    },
    768: {
      slidesPerView: 3
    },
    1024: {
      slidesPerView: 4
    },
    1400: {
      slidesPerView: 5
    }
  }
});

  /*****ICON WITH TEXT SLIDER FUNCTIONALITY****/

  const iconWithTextSlider= new Swiper(".icon-with-text-slider",{
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  })

  /******VIDEO PLAYING FUNCTIONALITY*****/

  const playTrigger = document.querySelectorAll("[playTrigger]");
  if(playTrigger.length > 0){
    playTrigger.forEach(function(e){
      e.addEventListener("click",function(){
        this.closest("[videoWrapper]").querySelector("video").play();
        this.classList.add("hidden");
      })
    })
  }

  const videoTriggers = document.querySelectorAll("[videoWrapper] video");
  if(videoTriggers.length > 0){
    videoTriggers.forEach(function(e){
      e.addEventListener("click",function(){
        if(!this.paused || !this.ended){
          this.pause();
          this.closest("[videoWrapper]").querySelector("[playTrigger]").classList.remove("hidden");
        }
      })
      e.addEventListener("ended",function(){
          this.closest("[videoWrapper]").querySelector("[playTrigger]").classList.remove("hidden");
          this.load();
      })
    })
  }
})();



// Initialize Swiper only on mobile screens
  function initSwiperMulti() {
    if (window.innerWidth < 768) {
      new Swiper('.multi-column-section', {
        slidesPerView: 1.25,
        spaceBetween: 0
      });
    }
  }

  // // Run swiper initialization on load and on resize
  // document.addEventListener('DOMContentLoaded', initSwiperMulti);
  // window.addEventListener('resize', function() {
  //   // Remove existing swiper instance if necessary and reinitialize
  //   if (document.querySelector('.multi-column-section').swiper) {
  //     document.querySelector('.multi-column-section').swiper.destroy();
  //     document.querySelector('.multi-column-section .swiper-wrapper').classList.remove('swiper-wrapper-initialized');
  //     initSwiperMulti();
  //   }
  // });